import React, { useState, useEffect, useContext, useRef } from "react";
import "../css/CommonDesign.css";
import bikkuri from "../images/bikkuri.svg";
import icon_batsu from "../images/batsu.svg";
import icon_sankaku from "../images/sankaku.svg";
import icon_maru from "../images/maru.svg";
import icon_minus from "../images/icon_minus.png";
import icon_hatena from "../images/hatena.svg";
import hatena from "../images/hatena.svg";
import { useLocation } from "react-router-dom";
import { Breadcrumbs, Container, Link, Stack, Backdrop, CircularProgress } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { MsgContext } from "../../App";
import parse from 'html-react-parser';
import axios from "axios";
import { API } from "./constantsFront";
import MenuMenu from "./MenuMenu";
import { compIconConversion, dataJudge, priorityJudge, PriorityJudgePlantRadio, TableTitle } from "./D001Common";

/**
 * 判定結果詳細
 * @returns 
 */
function D002SearchResult() {
  const navigate = useNavigate();

  // 輸出可否判定結果
  const [judge, setJudge] = useState([<p class="judge">検索中です。しばらくお待ちください。</p>]);

  const [radioTypeData, setRadioTypeData] = useState(""); // 放射能
  const [isLoading, setIsLoading] = useState(false);  // Loading

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // POSTデータ
  let body = { authKey: API.API_KEY };

  const location = useLocation();
  let dataList = [];
  let productName;
  if (location.state != null) {
    dataList = location.state.dataList;
    productName = location.state.productName;
  }

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 初期表示
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    window.scrollTo(0, 0);
    setTable();

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, []);

  // テーブル作成
  async function setTable() {
    try {
      if (dataList.length != 0) {
        let judgeContent = [];
        let tableData = [];

        let res;
        let planNA;
        let animalNA;
        let radioNA;
        let racNA;
        let euNA;
        let planNADataList = [];
        let animalNADataList = [];
        let radioNADataList = [];
        let racNADataList = [];
        let euNADataList = [];
        // 植物検疫もしくは動物検疫のNAデータ取得
        body.code = "NA";
        // 植物用NAデータ取得
        res = await axios.post("/m_plan_quar/select", body);
        planNADataList = res.data.dataList;
        // 動物用NAデータ取得
        res = await axios.post("/m_animal_quar/select", body);
        animalNADataList = res.data.dataList;
        // 放射能用NAデータ取得
        res = await axios.post("/m_radio_active/select", body);
        radioNADataList = res.data.dataList;
        // 残留農薬用NAデータ取得
        res = await axios.post("/m_rac_quar/select", body);
        racNADataList = res.data.dataList;
        // 食品添加物用NAデータ取得
        res = await axios.post("/m_eu_quar/select", body);
        euNADataList = res.data.dataList;

        if (
          planNADataList.length > 0
          && animalNADataList.length > 0
          && radioNADataList.length > 0
          && racNADataList.length > 0
          && euNADataList.length > 0
        ) {
          planNA = planNADataList[0];
          animalNA = animalNADataList[0];
          radioNA = radioNADataList[0];
          racNA = racNADataList[0];
          euNA = euNADataList[0];
        } else {
          return setMsg("NAデータが存在しません。管理者にお問い合わせください。");
        }

        // Loading
        setIsLoading(true);

        tableData = await setTableData(dataList, planNA, animalNA, radioNA, racNA, euNA);

        judgeContent.push(
          <div>
            <div>
              {/* <p class="table-title">{productName}</p> */}
              <p class="table-title">{TableTitle(dataList, productName)}</p>
              <div class="table-scroll">
                <table bordercolor="gainsboro" style={{ tableLayout: "fixed", width: "100%" }}>
                  <thead class="table-header">
                    <tr>
                      {/* <td>品目</td> */}
                      <td>輸出対象国</td>
                      <td style={{ backgroundColor: "#1B335E", color: "#FFFFFF", border: "3px solid #1B335E" }}>総合判定</td>
                      <td>植物検疫</td>
                      {/* <td>動物検疫及び<br />食品衛生</td> */}
                      <td>動物衛生・食品衛生</td>
                      <td>漁獲証明書</td>
                      <td>放射性物質</td>
                      <td>残留農薬</td>
                      <td>食品添加物</td>
                    </tr>
                  </thead>
                  <tbody class="table-body" onClick={regulationClick} style={{ cursor: "hand", cursor: "pointer" }}>
                    {tableData}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
        setJudge(judgeContent);
      } else {
        setJudge([<p class="judge">該当するデータが存在しませんでした</p>]);
      }
    } catch (err) {
      console.log(err)
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    } finally {
      setIsLoading(false);
    }
  }

  // テーブルのデータ作成
  async function setTableData(dataList, planNA, animalNA, radioNA, racNA, euNA) {
    let tableData = [];
    for (let i in dataList) {
      let countryName = dataList[i].country_name;
      let productCode = dataList[i].product_code;
      // 梱包
      let minPackingList = [];
      // 放射線データ取得
      let radioDataList = [];

      // 総合判定
      let compJudgeSentence = {
        icon: "", // 輸出可否コード
        supplement: "", // 補足文言
        // img: "",  // 画像ファイル
      }
      // 植物判定
      let planSentence = {
        icon: "",
        supplement: "",
        img: "",
      }
      // 動物判定
      let animalSentence = {
        icon: "",
        supplement: "",
        img: "",
      }
      // 漁獲証明書判定
      let marineSentence = {
        icon: "",
        supplement: "",
        img: "",
      }
      // 放射能判定
      let radioSentence = {
        icon: "",
        supplement: "",
        img: "",
      }
      // 残留農薬判定
      let racSentence = {
        icon: "",
        supplement: "",
      }
      // 食品添加物判定
      let euSentence = {
        icon: "",
        supplement: "",
      }
      let icon = "";
      let supplement = "";

      let planJudge = "";
      let animalJudge = "";
      let marineJudge = "";
      let radioJudge = "";
      let racJudge = "";
      let euJudge = "";

      // 植物検疫用
      let iconArr = [];
      // let exIcon = "";

      // 植物判定
      if (dataList[i].plan_product_code) {
        body.countryCode = dataList[i].country_code;
        body.productCode = dataList[i].plan_product_code;
        const res = await axios.post("/m_plan_quar/select/packing", body);
        minPackingList = res.data.dataList;
      }
      if (minPackingList.length > 0) {
        for (let j in minPackingList) {
          if (dataJudge(minPackingList[j].exportability_code)) {
            icon = minPackingList[j].exportability_code;
            supplement = minPackingList[j].supplement;
          } else {
            icon = planNA.exportability_code;
            supplement = planNA.supplement;
          }

          // 1番目の梱包方法詳細を取得
          if (i == 0) {
            planSentence = {
              icon: icon,
              supplement: supplement,
            }
          }

          // 判定アイコン取得
          iconArr.push(icon);

          // if (plantPriorityJudge(exIcon, icon)) {
          //   exIcon = icon;
          // }
        }

        // 植物検疫用アイコン判定
        // if (exIcon) {
        //   planSentence.icon = exIcon;
        // } else {
        //   // アイコンが全て同じか判定
        //   const isAllEqual = array => array.every(value => value === array[0]);
        //   if (isAllEqual(iconArr)) {
        //     planSentence.icon = iconArr[0];
        //   } else {
        //     planSentence.icon = "△";
        //   }
        // }
        // 植物検疫用アイコン判定
        planSentence.icon = PriorityJudgePlantRadio(iconArr);

      } else {
        planSentence = {
          icon: planNA.exportability_code,
          supplement: planNA.supplement,
        }
      }

      // 動物判定
      if (dataList[i].animal_product_code) {
        if (dataJudge(dataList[i].animal_exportability_code)) {
          icon = dataList[i].animal_exportability_code;
          supplement = dataList[i].animal_supplement;
        } else {
          icon = animalNA.exportability_code;
          supplement = animalNA.supplement;
        }
        animalSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        animalSentence = {
          icon: animalNA.exportability_code,
          supplement: animalNA.supplement,
        }
      }

      // 漁獲証明書判定
      if (dataList[i].marine_exportability_code) {
        if (dataJudge(dataList[i].marine_exportability_code)) {
          icon = dataList[i].marine_exportability_code;
          supplement = dataList[i].marine_supplement;
        } else {
          icon = animalNA.marine_exportability_code;
          supplement = animalNA.marine_supplement;
        }
        marineSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        marineSentence = {
          icon: animalNA.marine_exportability_code,
          supplement: animalNA.marine_supplement,
        }
      }

      // 放射能判定
      if (dataList[i].product_name) {
        radioDataList = await getRadioData(dataList[i].country_code, dataList[i].product_name);
      }
      if (radioDataList.length > 0) {
        let iconRadArr = [];

        for (let j in radioDataList) {
          if (dataJudge(radioDataList[j].exportability_code)) {
            icon = radioDataList[j].exportability_code;
            supplement = radioDataList[j].supplement;
          } else {
            //　国別NAデータ取得
            body = { authKey: API.API_KEY };
            body.productCode = "NA";
            body.countryCode = dataList[i].country_code;
            let res = await axios.post("/m_radio_active_product/select/radio", body);
            if (res.data.dataList.length > 0) {
              let specifyRadioNA = res.data.dataList[0];
              icon = specifyRadioNA.exportability_code;
              supplement = specifyRadioNA.supplement;
            } else {
              icon = radioNA.exportability_code;
              supplement = radioNA.supplement;
            }
          }
          if (priorityJudge(radioSentence.icon, icon)) {
            radioSentence = {
              icon: icon,
              supplement: supplement,
            }
          }
          // 判定アイコン取得
          iconRadArr.push(icon);

        }
        // 放射性物質アイコン判定
        radioSentence.icon = PriorityJudgePlantRadio(iconRadArr);

      } else {
        //　国別NAデータ取得
        body = { authKey: API.API_KEY };
        body.productCode = "NA";
        body.countryCode = dataList[i].country_code;
        let res = await axios.post("/m_radio_active_product/select/radio", body);
        if (res.data.dataList.length > 0) {
          let specifyRadioNA = res.data.dataList[0];
          radioSentence = {
            icon: specifyRadioNA.exportability_code,
            supplement: specifyRadioNA.supplement,
          }
        } else {
          radioSentence = {
            icon: radioNA.exportability_code,
            supplement: radioNA.supplement,
          }
        }
      }

      // 残留農薬判定
      if (dataList[i].rac_product_code) {
        if (dataJudge(dataList[i].rac_exportability_code)) {
          icon = dataList[i].rac_exportability_code;
          supplement = dataList[i].rac_supplement;
        } else {
          icon = racNA.exportability_code;
          supplement = racNA.supplement;
        }
        racSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        racSentence = {
          icon: racNA.exportability_code,
          supplement: racNA.supplement,
        }
      }

      // 食品添加物判定
      if (dataList[i].eu_product_code) {
        if (dataJudge(dataList[i].eu_exportability_code)) {
          icon = dataList[i].eu_exportability_code;
          supplement = dataList[i].eu_supplement;
        } else {
          icon = euNA.exportability_code;
          supplement = euNA.supplement;
        }
        euSentence = {
          icon: icon,
          supplement: supplement,
        }
      } else {
        euSentence = {
          icon: euNA.exportability_code,
          supplement: euNA.supplement,
        }
      }

      planJudge = compIconConversion(planSentence.icon);
      animalJudge = compIconConversion(animalSentence.icon);
      marineJudge = compIconConversion(marineSentence.icon);
      radioJudge = compIconConversion(radioSentence.icon);
      racJudge = compIconConversion(racSentence.icon);
      euJudge = compIconConversion(euSentence.icon);

      // 総合判定(植物or動物)
      if (priorityJudge(planSentence.icon, animalSentence.icon)) {
        compJudgeSentence = {
          icon: animalSentence.icon,
          supplement: animalSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: planSentence.icon,
          supplement: planSentence.supplement,
        }
      }
      // (漁獲証明書)
      if (priorityJudge(compJudgeSentence.icon, marineSentence.icon)) {
        compJudgeSentence = {
          icon: marineSentence.icon,
          supplement: marineSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (放射能)
      if (priorityJudge(compJudgeSentence.icon, radioSentence.icon)) {
        compJudgeSentence = {
          icon: radioSentence.icon,
          supplement: radioSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (残留農薬)
      if (priorityJudge(compJudgeSentence.icon, racSentence.icon)) {
        compJudgeSentence = {
          icon: racSentence.icon,
          supplement: racSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }
      // (食品添加物)
      if (priorityJudge(compJudgeSentence.icon, euSentence.icon)) {
        compJudgeSentence = {
          icon: euSentence.icon,
          supplement: euSentence.supplement,
        }
      } else {
        compJudgeSentence = {
          icon: compJudgeSentence.icon,
          supplement: compJudgeSentence.supplement,
        }
      }

      // 総合判定をアイコンファイルと文言に変換
      let result = compIconConversion(compJudgeSentence.icon);

      tableData.push(
        <tr>
          {/* <td class="country-name-td">{productCode}</td> */}
          <td class="country-name-td">{countryName}</td>
          <td class="judge-td" style={{ border: "3px solid #1B335E" }}>{result}</td>
          <td class="judge-td">{planJudge}</td>
          <td class="judge-td">{animalJudge}</td>
          <td class="judge-td">{marineJudge}</td>
          <td class="judge-td">{radioJudge}</td>
          {/* <td class="judge-td" style={{ backgroundColor: "#FFE0E0", color: "#F25151" }}><img src={bikkuri} /><br />要確認</td>
          <td class="judge-td" style={{ backgroundColor: "#FFE0E0", color: "#F25151" }}><img src={bikkuri} /><br />要確認</td> */}
          <td class="judge-td">{racJudge}</td>
          <td class="judge-td">{euJudge}</td>
        </tr>
      );
    }
    return tableData;
  }


  // 放射能データ
  async function getRadioData(country_code, product_code) {
    let radioDataList = [];
    body = { authKey: API.API_KEY };
    body.countryCode = country_code;
    body.productCode = product_code;
    let res = await axios.post("/m_radio_active_product/select/radio", body);
    radioDataList = res.data.dataList;
    return radioDataList;
  }

  // 規制画面
  function regulationClick() {
    return navigate("/D003SearchDetail", { state: { dataList: dataList, productName: productName } });
  }

  // TOP画面
  function backClick() {
    // return navigate("/");
    return navigate("/", { state: { dataList: dataList, productName: productName } });
  }

  return (
    <>
      <MenuMenu sel={1} />
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                {/* Loading */}
                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>

                <Stack spacing={2}>
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      規制情報詳細
                    </Typography>
                  </Breadcrumbs>
                  <h1>規制情報詳細</h1>
                  {/* <p>「植物検疫」、「動物検疫及び食品衛生」、「放射性物質」、「残留農薬」、「食品添加物」の５つの規制を基に判定結果を出しています。各規制の詳細は「規制の詳細を見る」ボタンをクリックするとご覧いただけます。</p> */}
                  <p>「植物検疫」、「動物検疫」、「放射性物質」の３つの要件・規制を基に簡易判定結果を出しています。各規制の詳細、「残留農薬」、「食品添加物」の規制内容については「規制の詳細を⾒る」ボタンをクリックするとご覧いただけます。</p>
                  <div className="center">
                    {judge}
                  </div>
                  <div style={{ width: "150px", margin: "10px 0 0 auto" }} class="button">
                    <input type="button" onClick={regulationClick} class="buttonDefault" value="規制の詳細を見る" />
                  </div>
                  <div style={{
                    display: "flex"
                    , justifyContent: "center"
                    , position: "relative"
                    , flexWrap: "wrap"
                    , marginTop: "40px"
                    , marginBottom: "40px"
                  }}>
                    <input type="button" style={{ width: "150px", color: "#1B335E", margin: "0 10px" }} value="戻る" class="buttonDefault graylBtn" onClick={backClick} />
                  </div>
                  {/* <Button className="search_button" onClick={() => regulationClick()}>規制の詳細を見る</Button> */}
                  {/* <Button className="search_button" href="./">戻る</Button> */}
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default D002SearchResult;